<template>
  <dialog ref="dialog" class="bridge-dialog" :aria-label="title" @cancel.prevent="requestClose" @close="onNativeClose">
    <header class="bridge-dialog-header">
      <h2 class="bridge-dialog-title">{{ title }}</h2>
      <aha-button icon-only size="xs" variant="tertiary" aria-label="Close" :disabled="busy" @click="requestClose">
        <aha-icon name="system-x" size="14" decorative></aha-icon>
      </aha-button>
    </header>
    <div class="bridge-dialog-body">
      <slot></slot>
    </div>
    <footer v-if="$slots.footer" class="bridge-dialog-footer">
      <slot name="footer"></slot>
    </footer>
  </dialog>
</template>

<script>
import nativeAhaElements from './nativeAhaElements'

export default {
  name: 'StripeBridgeDialog',
  components: { ...nativeAhaElements },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    busy: { type: Boolean, default: false },
  },
  watch: {
    open: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          const dialog = this.$refs.dialog
          if (!dialog) return
          if (value && !dialog.open) dialog.showModal()
          else if (!value && dialog.open) dialog.close()
        })
      },
    },
  },
  methods: {
    requestClose() {
      if (!this.busy) this.$emit('close')
    },
    onNativeClose() {
      if (this.open) this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.bridge-dialog {
  width: min(640px, calc(100vw - 32px));
  max-height: calc(100vh - 64px);
  padding: 0;
  border: 0;
  border-radius: var(--aha-radius-lg);
  background: var(--aha-bg-elevated);
  color: var(--aha-text-default);
  font-family: var(--aha-font-product);

  &::backdrop {
    background: var(--aha-bg-overlay);
  }
}

.bridge-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--aha-space-16);
  padding: var(--aha-space-24) var(--aha-space-24) var(--aha-space-8);
}

.bridge-dialog-title {
  margin: 0;
  font-size: var(--aha-size-h4);
  font-weight: 600;
  line-height: 1.3;
}

.bridge-dialog-body {
  display: flex;
  flex-direction: column;
  gap: var(--aha-space-12);
  padding: var(--aha-space-8) var(--aha-space-24);
  font-size: var(--aha-size-default);
  line-height: 1.5;
}

.bridge-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--aha-space-8);
  padding: var(--aha-space-16) var(--aha-space-24) var(--aha-space-24);
}
</style>
